const lenis = new Lenis({
    smoothWheel: !0,
    smoothTouch: !1,
    normalizeWheel: !0,
    ignore: el => el.classList.contains("scroll-section")
});
lenis.on("scroll", ScrollTrigger.update),
gsap.ticker.add(time => {
    lenis.raf(time * 700)
}
),
gsap.ticker.lagSmoothing(0);

// ---------product-page-tabs-----------------

document.addEventListener("DOMContentLoaded",()=>{
    const tabs = document.querySelectorAll(".product-tabs li");
    const tabs_content = document.querySelectorAll(".tabs-content");

    tabs.forEach((tab,idx)=>{
        tab.addEventListener("click",()=>{

            tabs.forEach(t=>{t.classList.remove("active")})

            tabs_content.forEach(con=>{con.classList.remove("active")})

            tab.classList.add("active");
            tabs_content[idx].classList.add("active");


        })
    })
})

// ---------product-page-tabs-----------------

// -----------------menu------------------

// document.addEventListener("DOMConttentLoaded",()=>{
    function dMenuToggle(){
        document.querySelector(".menu-container").classList.toggle("active");
        document.querySelector(".menu-overlay").classList.toggle("active");
        document.querySelector(".header-main-container").classList.toggle("active");
        document.querySelector(".header-menu").classList.toggle("active");
    }


// })

// -----------------menu------------------

// ----------------menu-accordian-start--------------

document.addEventListener("DOMContentLoaded", () => {

  const items = document.querySelectorAll(".menu-mid-part-accordian");

  items.forEach(item => {
    const head = item.querySelector(".accordian-head");
    const content = item.querySelector(".accordian-links");

    head.addEventListener("click", () => {

      items.forEach(i => {
        if (i !== item) {
          i.classList.remove("active");
          i.querySelector(".accordian-links").style.maxHeight = null;
        }
      });

      item.classList.toggle("active");

      content.style.maxHeight = item.classList.contains("active")
        ? content.scrollHeight + "px"
        : null;

    });

  });

});

// ----------------menu-accordian-end--------------


// ========================= Draggable JS ==================================

function enableLeftClickDragScroll(container) {
    if (!container)
        return;
    let isDragging = !1
      , dragStarted = !1
      , startX = 0
      , scrollStart = 0;
    const dragThreshold = 5;
    container.addEventListener("mousedown", e => {
        e.button === 0 && (isDragging = !0,
        dragStarted = !1,
        startX = e.pageX,
        scrollStart = container.scrollLeft,
        container.classList.add("is-dragging"),
        e.preventDefault())
    }
    ),
    container.addEventListener("mousemove", e => {
        if (!isDragging)
            return;
        const deltaX = e.pageX - startX;
        !dragStarted && Math.abs(deltaX) > dragThreshold && (dragStarted = !0),
        dragStarted && (container.scrollLeft = scrollStart - deltaX)
    }
    ),
    container.addEventListener("mouseup", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("mouseleave", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("click", e => {
        dragStarted && (e.preventDefault(),
        e.stopPropagation(),
        dragStarted = !1)
    }
    ),
    container.classList.add("is-draggable")
}
function waitForElementAndInit(selector) {
    document.querySelectorAll(selector).forEach(el => {
        el._dragInitialized || (enableLeftClickDragScroll(el),
        el._dragInitialized = !0)
    }
    ),
    new MutationObserver(mutations => {
        for (const mutation of mutations)
            mutation.addedNodes.forEach(node => {
                node instanceof HTMLElement && (node.matches(selector) && !node._dragInitialized && (enableLeftClickDragScroll(node),
                node._dragInitialized = !0),
                node.querySelectorAll?.(selector)?.forEach(el => {
                    el._dragInitialized || (enableLeftClickDragScroll(el),
                    el._dragInitialized = !0)
                }
                ))
            }
            )
    }
    ).observe(document.body, {
        childList: !0,
        subtree: !0
    })
}
document.addEventListener("DOMContentLoaded", () => {
    [".product-grid", ".cust-mid-collection-container","#predictive-search-results-products-list"].forEach(selector => {
        waitForElementAndInit(selector)
    }
    )
}
);

// ========================= Draggable JS ==================================



// ========== Size Chart Start ==========

function  sizeChartToggle(btn){
    const mainProduct = btn.closest("product-info");
    const currentChart = mainProduct.querySelector(".pdp-size-chart");
    currentChart.classList.toggle("active");
    document.addEventListener("scroll", () => {
      if (currentChart.classList.contains("active")) {
        currentChart.classList.remove("active");
      }
    });
  }
// ========== Size Chart End ==========




// dev-03 header

// home header js for scroll up down.......

document.addEventListener("DOMContentLoaded", () => {
    if(document.querySelector(".home-page")) {

    const header = document.querySelector('.header');
    const footer = document.querySelector('.cust-footer-wrapper');
    let lastScroll = 0;
    
    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;
    
        if (currentScroll <= innerHeight) {
            header.classList.remove('change-color');
        } else {
            header.classList.add('change-color');
        }
    
    
        lastScroll = currentScroll;
    })
    }

});
    

// dev-03 header


// image-new-slider
document.addEventListener("DOMContentLoaded",()=>{
const target = document.querySelector("product-recommendations");

if (target) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
        obs.disconnect();
      if (mutation.type === "childList") {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
      }
    }
  });

  observer.observe(target, {
    childList: true, // watch children add/remove
  });
}
const collectionProducts = document.querySelector(".active-facets.active-facets-desktop");
if (collectionProducts) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
    }
  });

  observer.observe(collectionProducts, {
    childList: true, // watch children add/remove,
    subtree: true,
  });
}


document.querySelectorAll('.productSwiper').forEach((slider) => {
      new Swiper(slider, {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  allowTouchMove: true, // ✅ enable touch
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: slider.querySelector('.swiper-button-next'),
    prevEl: slider.querySelector('.swiper-button-prev'),
  },
});

    });

    // for product-rec

});
